// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh1[data-v-46a88b29] {\n  font-size: 3rem;\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
